import { CreateRequest, GetLink, Http, RequestMethod, Resource, UseCase, merge } from '@mdd/api';
import { ReplaceParams } from './ReplaceParams';

export namespace UpdateResource {
    export interface Params<T extends Resource<string>> {
        resource: T;
        updates?: Partial<T>;
        rel: string;
        queryParams?: object;
        method?: RequestMethod;
    }
}

export class UpdateResource<T extends Resource<string>>
    implements UseCase<UpdateResource.Params<T>, Promise<T>>
{
    private getLink = new GetLink<string>();
    private createRequest = new CreateRequest();
    private replaceParams = new ReplaceParams<string>();

    constructor(private http: Http) {}

    execute({ resource, rel, updates, queryParams, method }: UpdateResource.Params<T>): Promise<T> {
        let link = this.getLink.execute({ parent: resource, rel })!.href;
        if (queryParams) {
            link = this.replaceParams.execute({ link, queryParams });
        }

        let httpMethod = method;
        if (!httpMethod) {
            httpMethod = 'PUT';
        }

        if (updates) {
            return this.http
                .request<T, T>(
                    this.createRequest.execute({
                        method: httpMethod,
                        url: link,
                        body: merge.recursive({}, resource, updates)
                    })
                )
                .then((response) => response.body!);
        } else {
            return this.http
                .request<void, T>(
                    this.createRequest.execute({
                        method: httpMethod,
                        url: link
                    })
                )
                .then((response) => response.body!);
        }
    }
}
